import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatSliderModule } from '@angular/material/slider';
import { FormsModule } from '@angular/forms';

import { CustomButtonsModule } from '@shared/buttons';
import { MaskOpacityComponent } from './mask-opacity.component';

@NgModule({
  imports: [
    FormsModule,
    CommonModule,
    MatIconModule,
    CustomButtonsModule,
    MatSliderModule,
  ],
  declarations: [MaskOpacityComponent],
  exports: [MaskOpacityComponent],
  providers: [],
})
export class MaskOpacityModule {}
